/** Connexion Google OAuth — réactivée (baseline stable + filtre suspension corrigé). */
export const MAIL_GOOGLE_OAUTH_ENABLED = true;
